export interface PriceChange {
    change: number;
    changePercent: number;
    isPositive: boolean;
}

class HouseInformationHelper {
    static findNearestDate(dates: Date[], targetDate: Date): Date {
        let closestDate = dates[0];
        for (const date of dates) {
            if (Math.abs(date.getTime() - targetDate.getTime()) < Math.abs(closestDate.getTime() - targetDate.getTime())) {
                closestDate = date;
            }
        }
        return closestDate;
    }

    static calculatePriceChange(timeSeries: any, date: Date): PriceChange | null {
        if (!timeSeries || !timeSeries.v || !timeSeries.d || timeSeries.v.length < 2) {
            return null;
        }

        const values = timeSeries.v;
        const dates = timeSeries.d.map((dateString: string) => new Date(dateString));

        const currentDate = this.findNearestDate(dates, new Date());
        const targetDate = this.findNearestDate(dates, date);
        const currentValue = values[dates.indexOf(currentDate)];
        const targetValue = values[dates.indexOf(targetDate)];

        if (targetValue === null) {
            return null;
        }

        const change = currentValue - targetValue;
        const changePercent = ((change / targetValue) * 100);
        const isPositive = change >= 0;

        return {
            change: Math.abs(change),
            changePercent: Math.abs(changePercent),
            isPositive
        };
    }

    static getOneMonthAgoDate(): Date {
        const date = new Date();
        date.setDate(date.getDate() - 30);
        return date;
    }

    static getOneYearAgoDate(): Date {
        const date = new Date();
        date.setDate(date.getDate() - 365);
        return date;
    }

    static getOneDayAgoDate(): Date {
        const date = new Date();
        date.setDate(date.getDate() - 2);
        return date;
    }
}

export default HouseInformationHelper;

